// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"R9-z"};